module.exports = __webpack_public_path__ + "img/aiIcon-faceSearch.bdd5584a.svg";